// For more information about this file see https://dove.feathersjs.com/guides/cli/service.shared.html
import type { ClientApplication } from '../../client';
import type {
  Cast,
  CastData,
  CastPatch,
  CastQuery,
  CastService,
  CastSearchResult,
  CastSearchResults,
  KnownForItem,
} from './cast.class';

export type {
  Cast,
  CastData,
  CastPatch,
  CastQuery,
  CastSearchResult,
  CastSearchResults,
  KnownForItem,
};

export type CastClientService = Pick<CastService, (typeof castMethods)[number]>;

export const castPath = 'api/cast';

export const castMethods: Array<keyof CastService> = ['find', 'get', 'create', 'patch', 'remove'];

export const castClient = (client: ClientApplication) => {
  const connection = client.get('connection');

  client.use(castPath, connection.service(castPath), {
    methods: castMethods,
  });
};

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [castPath]: CastClientService;
  }
}
